<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
               :fullscreen="false"
  >
    <surveys-form ref="form" v-model="form" :input-errors="inputErrors" @save="create"/>
  </crud-create>
</template>

<script>

import SurveysProvider from "../../../../providers/SurveysProvider";

import {CrudCreate, ClientError} from '@dracul/common-frontend'

import SurveysForm from "../../../../forms/SurveysForm";


export default {
  name: "SurveysCreate",

  components: {SurveysForm, CrudCreate},

  props: {
    open: {type: Boolean, default: true}
  },

  data() {
    return {
      title: 'delivery.surveys.creating',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      form: {
        name: '',
        description: '',
        questions: []
      }
    }
  },

  methods: {
    create() {
      if (this.validate()) {
        this.loading = true
        SurveysProvider.createSurvey(this.form).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createPromo)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    },
    validate(){
      if(!this.$refs.form.validate()) return false
      if(!this.form.questions.length) return false
      for(const question of this.form.questions) {
        if(!question.question) return false
        if(question.options.length < 2) return false
        for(const option of question.options){
          if(!option.value) return false
        }
      }
      return true
    }

  },

  mounted(){
    if(this.$refs.form) this.validate()
  }
}
</script>

<style scoped>

</style>

